const FormActionTypes = {
	SUBMIT: "submit",
	GROUP: "group",
	SCRIPT: "script",
	LINK: "link",
	SEARCHER: "searcher",
	GRID: "grid",
};

export default FormActionTypes
